import React, { useEffect, useRef } from 'react';
import './css/Profile.css'; // Assuming you have a CSS file for additional styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Profile = () => {
  const sectionsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    sectionsRef.current.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      sectionsRef.current.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  return (
    <div className="profile-container">
      <div className="card work-experience" ref={(el) => (sectionsRef.current[0] = el)}>
        <div className="card-body">
          <h2 className="card-title">Work Experience</h2>
          <ul>
            <li><strong>Company A</strong> - DevOps Engineer (2015 - Present)</li>
            <li><strong>Company B</strong> - Systems Engineer (2010 - 2015)</li>
          </ul>
        </div>
      </div>
      
      <div className="card technical-skills" ref={(el) => (sectionsRef.current[1] = el)}>
        <div className="card-body">
          <h2 className="card-title">Technical Skills</h2>
          <ul>
            <li>AWS, Azure, Kubernetes, Docker, Terraform, Ansible</li>
            <li>ELK, Grafana, Loki, Linux, Windows</li>
            <li>PowerShell, Shell Script, Python</li>
          </ul>
        </div>
      </div>
      
      <div className="card personal-skills" ref={(el) => (sectionsRef.current[2] = el)}>
        <div className="card-body">
          <h2 className="card-title">Personal Skills</h2>
          <ul>
            <li>Problem-solving</li>
            <li>Team collaboration</li>
            <li>Effective communication</li>
          </ul>
        </div>
      </div>
      
      <div className="card education" ref={(el) => (sectionsRef.current[3] = el)}>
        <div className="card-body">
          <h2 className="card-title">Education</h2>
          <ul>
            <li><strong>Bachelor's Degree in Computer Science</strong> - University X (2006 - 2010)</li>
          </ul>
        </div>
      </div>
      
      <div className="card personal-details" ref={(el) => (sectionsRef.current[4] = el)}>
        <div className="card-body">
          <h2 className="card-title">Personal Details</h2>
          <ul>
            <li><FontAwesomeIcon icon={faMapMarkerAlt} className="fa-icon" /> Location: City, Country</li>
            <li>Date of Birth: January 1, 1985</li>
          </ul>
        </div>
      </div>
      
      <div className="card communication-details" ref={(el) => (sectionsRef.current[5] = el)}>
        <div className="card-body">
          <h2 className="card-title">Communication Details</h2>
          <ul>
            <li><FontAwesomeIcon icon={faEnvelope} className="fa-icon" /> Email: <a href="mailto:utkarsh@example.com">utkarsh@example.com</a></li>
            <li><FontAwesomeIcon icon={faPhone} className="fa-icon" /> Phone: +1234567890</li>
            <li><FontAwesomeIcon icon={faLinkedin} className="fa-icon" /> LinkedIn: <a href="https://www.linkedin.com/in/utkarsh" target="_blank" rel="noopener noreferrer">linkedin.com/in/utkarsh</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Profile;